import { ConstructClassWithPrivateMembers } from '../helpers/ClassWithPrivateMembers';
import { HasFactoryWaterMark, MakeFactory } from '../../classes/class-helpers/factory';
import { IsObject } from '../../helpers';
import { BaseClass } from '../../classes/class-helpers/base-class';
export const ACTIVABLE_PRIVATE = Symbol('activable-private');
export function ConstructActivable(instance, hook) {
    ConstructClassWithPrivateMembers(instance, ACTIVABLE_PRIVATE);
    const privates = instance[ACTIVABLE_PRIVATE];
    privates.activated = false;
    privates.promise = Promise.resolve();
    privates.listeners = new Map();
    const activate = hook.activate;
    privates.activate = () => {
        return new Promise((resolve) => {
            resolve(activate.call(instance));
        });
    };
    const deactivate = hook.deactivate;
    privates.deactivate = () => {
        return new Promise((resolve) => {
            resolve(deactivate.call(instance));
        });
    };
}
export function IsActivable(value) {
    return IsObject(value)
        && value.hasOwnProperty(ACTIVABLE_PRIVATE);
}
const IS_ACTIVABLE_CONSTRUCTOR = Symbol('is-activable-constructor');
export function IsActivableConstructor(value, direct) {
    return (typeof value === 'function')
        && HasFactoryWaterMark(value, IS_ACTIVABLE_CONSTRUCTOR, direct);
}
export function ActivableActivate(instance) {
    const privates = instance[ACTIVABLE_PRIVATE];
    if (!privates.activated) {
        privates.promise = privates.promise
            .catch(() => {
        })
            .then(() => {
            return privates.activate()
                .then(() => {
                ActivableSetState(instance, true);
            }, (error) => {
                return privates.deactivate()
                    .then(() => Promise.reject(error));
            });
        });
    }
    return privates.promise;
}
export function ActivableDeactivate(instance) {
    const privates = instance[ACTIVABLE_PRIVATE];
    if (privates.activated) {
        privates.promise = privates.promise
            .catch(() => {
        })
            .then(() => {
            return privates.deactivate()
                .then(() => {
                ActivableSetState(instance, false);
            }, (error) => {
                console.error('deactivate should never fail !');
                ActivableSetState(instance, false);
                return Promise.reject(error);
            });
        });
    }
    return privates.promise;
}
function ActivableSetState(instance, activated) {
    const privates = instance[ACTIVABLE_PRIVATE];
    if (activated !== privates.activated) {
        privates.activated = activated;
        const iterator = privates.listeners.keys();
        let result;
        while (!(result = iterator.next()).done) {
            result.value.call(instance, activated);
        }
    }
    else {
        console.warn(`invalid ActivableSetState`);
    }
}
export function ActivableAddStateListener(instance, listener) {
    const privates = instance[ACTIVABLE_PRIVATE];
    if (privates.listeners.has(listener)) {
        return privates.listeners.get(listener);
    }
    else {
        let cleared = false;
        const clear = () => {
            if (!cleared) {
                cleared = true;
                privates.listeners.delete(listener);
            }
        };
        privates.listeners.set(listener, clear);
        return clear;
    }
}
function PureActivableFactory(superClass) {
    return class Activable extends superClass {
        constructor(...args) {
            const [hook] = args[0];
            super(...args.slice(1));
            ConstructActivable(this, hook);
        }
        get activated() {
            return this[ACTIVABLE_PRIVATE].activated;
        }
        activate() {
            return ActivableActivate(this);
        }
        deactivate() {
            return ActivableDeactivate(this);
        }
        addStateListener(listener) {
            return ActivableAddStateListener(this, listener);
        }
    };
}
export let Activable;
export function ActivableFactory(superClass) {
    return MakeFactory(PureActivableFactory, [], superClass, {
        name: 'Activable',
        instanceOf: Activable,
        waterMarks: [IS_ACTIVABLE_CONSTRUCTOR]
    });
}
Activable = class Activable extends ActivableFactory(BaseClass) {
    constructor(hook) {
        super([hook]);
    }
};
//# sourceMappingURL=implementation.js.map